import '~/entrypoints/application.css'

import * as Turbo from '@hotwired/turbo'
Turbo.start()

// Prefetch/corrida em turbo-frames às vezes devolve HTML sem o frame esperado.
// Em vez de "Content missing", recarrega a URL como visita normal.
document.addEventListener('turbo:frame-missing', (event) => {
  const url = event.detail.response?.url
  if (!url) return

  event.preventDefault()
  event.detail.visit(url)
})

import * as ActiveStorage from '@rails/activestorage'
ActiveStorage.start()

import '~/channels/cable_stream_source'

// Custom stream action: <turbo-stream action="visit" target="/path"> navega a página inteira
Turbo.StreamActions.visit = function () {
  Turbo.visit(this.getAttribute('target'))
}

import '~/confirmation'

import { Application } from '@hotwired/stimulus'
import { registerControllers } from 'stimulus-vite-helpers'

const application = Application.start()
const controllers = import.meta.glob('~/controllers/**/*_controller.js', { eager: true })
registerControllers(application, controllers)

import { createIcons, icons } from 'lucide'

function initLucide(root = document) {
  createIcons({ icons, root })
}

function hasLucidePlaceholder(node) {
  if (node.nodeType !== Node.ELEMENT_NODE) return false
  return (node.tagName === "I" && node.hasAttribute("data-lucide")) ||
         !!node.querySelector?.("i[data-lucide]")
}

document.addEventListener('turbo:load', () => initLucide())

new MutationObserver((mutations) => {
  for (const mutation of mutations) {
    for (const node of mutation.addedNodes) {
      if (hasLucidePlaceholder(node)) initLucide(node)
    }
  }
}).observe(document.documentElement, { childList: true, subtree: true })
